import { BaseScreenProps } from '../types'
import React from 'react'
import BottomContinueButton from '@/features/quiz/bottom-continue-button'
import useApiClient from '@/lib/apis/clients/useApiClient'
import { useMutation } from '@tanstack/react-query'
import { useRouter } from 'next/navigation'
import { CreatePaymentLink } from '@/lib/apis/treatments'
import { isPaymentAlreadyReceivedError } from '@/lib/apis/patient/orders'
import { useStore } from '@/lib/store'
import {
  NotificationItem,
  NotificationItemVariant,
} from '@/lib/models/NotificationItem'
import { usePricingAmountCents } from '@/lib/cms/pricing'
import { rewardId } from '@/features/rewards/web-loyalty-reward'
import { WlPricingDetails } from './pricing-details'

type Props = {} & BaseScreenProps

export default function WlServiceSelector({
  treatmentType,
  rewardResponse,
}: Props) {
  const client = useApiClient()
  const router = useRouter()
  const paymentLinkMutation = useMutation(
    CreatePaymentLink.mutation(client, treatmentType),
  )

  const showNotification = useStore((state) => state.showNotification)
  const baseAmountCents = usePricingAmountCents('weightLossInitialAssessment')

  return (
    <>
      <WlPricingDetails
        baseAmountCents={baseAmountCents}
        rewardResponse={rewardResponse}
      />

      <BottomContinueButton
        onClick={() => {
          paymentLinkMutation.mutate(
            { rewardId: rewardId(rewardResponse) },
            {
              onSuccess: (data) => {
                window.location.assign(data.checkoutUrl)
              },
              onError: (error) => {
                // The earlier checkout was paid, so retrying here would only fail again.
                // The portal shows the request's progress.
                if (isPaymentAlreadyReceivedError(error)) {
                  showNotification(
                    new NotificationItem(
                      'Payment already received.',
                      NotificationItemVariant.Success,
                    ),
                  )
                  router.push('/portal')
                  return
                }

                showNotification(
                  new NotificationItem(
                    'Something went wrong. Please try again later',
                    NotificationItemVariant.Error,
                  ),
                )
              },
            },
          )
        }}
        initial={true}
        show={true}
        buttonProps={{
          children: 'Continue to payment',
          loading: paymentLinkMutation.isPending,
        }}
      />
    </>
  )
}
